export default {
  title: {
    entrance: 'Guiding you<br /><b>to the right financial decisions</b>',
    main: 'At Polaris, we provide private wealth management <br />and retirement planning services to affluent clients who want <b>to make the most</b> of their financial resources, <b>preserve their wealth <br>and pass it on to future generations.</b>',
  },
};
